module.exports = __webpack_public_path__ + "img/temperategrove.f94ff6ea.webp";